import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/icon-right-white.png'
import _imports_1 from '../../assets/images/icon-right-red.png'


const _withScopeId = n => (_pushScopeId("data-v-4616abb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "section-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "top-title",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "200"
}, " CAPABILITIES ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "200"
}, " Offline Ad Agency, Redefining the Essence of True Brand Engagement ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icon-right-white"
}, null, -1))
const _hoisted_7 = { class: "capabilities-wraps" }
const _hoisted_8 = { class: "row align-items-center" }
const _hoisted_9 = {
  class: "col-lg-5",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "200"
}
const _hoisted_10 = {
  class: "nav nav-tabs capabilities-tabs d-block",
  id: "myTab",
  role: "tablist"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "icon-right-red"
  })
], -1))
const _hoisted_13 = {
  class: "col-lg-7",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "200"
}
const _hoisted_14 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_15 = { class: "capabilities-item-content" }
const _hoisted_16 = { class: "capabilities-img" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icon-right-white"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_router_link, {
          to: "/services",
          class: "default-btn",
          "data-aos": "fade-up",
          "data-aos-duration": "1200",
          "data-aos-delay": "200"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" VIEW ALL SERVICES "),
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "nav-item",
                  key: item.id
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["nav-link d-flex justify-content-between align-items-center", { active: _ctx.activeIndex === index }]),
                    onClick: ($event: any) => (_ctx.setActive(index))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(item.title), 1),
                    _hoisted_12
                  ], 10, _hoisted_11)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: _normalizeClass(['tab-pane', { active: _ctx.activeIndex === index }])
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                    _createElementVNode("p", null, _toDisplayString(item.shortDesc), 1),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("img", {
                        src: item.image,
                        alt: "capabilities"
                      }, null, 8, _hoisted_17)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(item.description), 1),
                    _createVNode(_component_router_link, {
                      to: "/service-details",
                      class: "read-more"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" READ MORE "),
                        _hoisted_18
                      ]),
                      _: 1
                    })
                  ])
                ], 2)), [
                  [_vShow, _ctx.activeIndex === index]
                ])
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}